import { AccountProfileModel } from '@/domain/models/account/account-profile-model'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import { capitalize } from '@mui/material'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { HelpCenterConfigType } from '../contexts/auth'
import { LinkConstants } from '@/main/routes/link-contants'
import { loadScript } from '@/main/helpers/load-script-helper'

export const generateNameInitials = (name: string) => {
  const values = name.split(' ')
  const firstName = values.at(0)!.trim()
  let lastName = values.at(-1)!.trim()
  if (firstName === lastName) {
    lastName = lastName.charAt(lastName.length - 1)
  }
  return `${firstName.charAt(0)}${
    lastName ? lastName.charAt(0) : firstName.charAt(1)
  }`.toUpperCase()
}

export const generateUserNameSummarized = (name: string) => {
  const values = name.split(' ')
  const firstName = values.at(0)!.trim()
  let lastName = values.at(-1)!.trim()
  if (firstName === lastName) {
    lastName = ''
  }
  return `${capitalize(firstName.toLocaleLowerCase())} ${capitalize(lastName.toLocaleLowerCase())}`
}

export const generateCapitalizedFirstName = (name: string) => {
  const [firstName] = name.length ? name.trim().split(/\s+/) : ['']
  return capitalize(firstName.toLocaleLowerCase())
}

export const getDisplayName = (
  accountProfile: AccountProfileModel,
  ldClient: LDClient | undefined
): string => {
  const enableNewSocialNameField = FeatureFlag.Key.ENABLED_NEW_SOCIAL_NAME_FIELD.getValue(ldClient)
  return enableNewSocialNameField && accountProfile.socialName
    ? accountProfile.socialName
    : accountProfile.name
}

export const getHelpCenterConfig = (
  accountProfile: AccountProfileModel,
  ldClient: LDClient | undefined
): HelpCenterConfigType => {
  const currentCompany = accountProfile?.company

  const companies =
    (FeatureFlag.Key.COMPANIES_WITH_CUSTOM_HELP_CENTER.getValue(
      ldClient
    ) as HelpCenterConfigType[]) ?? []

  const helpCenterConfig = companies.find(({ companyId: id }) => id === currentCompany.uniqueId)

  const currentConfig: HelpCenterConfigType = {
    companyId: helpCenterConfig?.companyId ?? currentCompany.uniqueId,
    hasChatBot: helpCenterConfig?.hasChatBot ?? false,
    hasWhatsApp: helpCenterConfig?.hasWhatsApp ?? true,
    hasLink: helpCenterConfig?.hasLink ?? true,
    redirectTo: helpCenterConfig?.redirectTo ?? LinkConstants.SUPPORT.url
  }

  if (currentConfig.hasChatBot && !currentConfig.hasWhatsApp) {
    loadScript({
      id: 'botmaker-chatbot',
      src: 'https://go.botmaker.com/rest/webchat/p/0EIQSZYAWL/init.js'
    })
  }

  return currentConfig
}
